import React from 'react';

const SvgEye2 = (props) => (
  <svg width={17} height={12} {...props}>
    <path
      fill="currentColor"
      d="M8.501 0C3.203 0 .687 4.409.076 5.667a.758.758 0 0 0 0 .664C.686 7.591 3.203 12 8.501 12c5.28 0 7.798-4.378 8.419-5.654a.787.787 0 0 0 0-.692C16.299 4.378 13.781 0 8.501 0zm0 2.25c2.133 0 3.863 1.68 3.863 3.75 0 2.07-1.73 3.75-3.863 3.75S4.638 8.07 4.638 6c0-2.07 1.73-3.75 3.863-3.75zm0 1.5c-1.28 0-2.318 1.007-2.318 2.25s1.038 2.25 2.318 2.25S10.82 7.243 10.82 6 9.781 3.75 8.501 3.75z"
    />
  </svg>
);

export default SvgEye2;
